import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";
import { setSnackbar } from "../../js/reducers/snackbar";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  alert: {
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    border: "none",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 12px 32px rgba(0, 0, 0, 0.16)",
      transform: "translateY(-2px)",
    },
  },
  success: {
    background: "linear-gradient(135deg, #00c853 0%, #009624 100%)",
    color: "#ffffff",
    "& .MuiAlert-icon": {
      color: "#ffffff",
    },
  },
  error: {
    background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
    color: "#ffffff",
    "& .MuiAlert-icon": {
      color: "#ffffff",
    },
  },
  warning: {
    background: "linear-gradient(135deg, #d97706 0%, #b45309 100%)",
    color: "#ffffff",
    "& .MuiAlert-icon": {
      color: "#ffffff",
    },
  },
  info: {
    background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
    color: "#ffffff",
    "& .MuiAlert-icon": {
      color: "#ffffff",
    },
  },
  message: {
    color: "#ffffff",
    fontWeight: 500,
    fontSize: "0.95rem",
    lineHeight: 1.5,
  },
  closeButton: {
    color: "rgba(255, 255, 255, 0.8)",
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
}));

const getIcon = (severity) => {
  switch (severity) {
    case "success":
      return <CheckCircleIcon />;
    case "error":
      return <ErrorIcon />;
    case "warning":
      return <WarningIcon />;
    case "info":
    default:
      return <InfoIcon />;
  }
};

const Notification = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const snackbarOpen = useSelector((state) => state.snackbar.snackbarOpen);
  const snackbarType = useSelector((state) => state.snackbar.snackbarType);
  const snackbarMessage = useSelector(
    (state) => state.snackbar.snackbarMessage
  );
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setSnackbar(false, snackbarType, snackbarMessage));
  };

  return (
    <Snackbar
      open={snackbarOpen}
      className={classes.root}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        elevation={6}
        onClose={handleClose}
        severity={snackbarType}
        icon={getIcon(snackbarType)}
        classes={{
          root: `${classes.alert} ${classes[snackbarType] || classes.info}`,
          message: classes.message,
        }}
        style={{ width: "auto" }}
      >
        <strong>{snackbarMessage}</strong>
      </Alert>
    </Snackbar>
  );
};

export default Notification;
